angular.module("UI8.components").component("accountPurchases", {
  template: `<div class="page" ng-if="$ctrl.hasPurchases">
      <div class="page__container container">
        <div class="page__hero">
          <h1 class="page__title">Your purchases</h1>
          <div class="page__description">Manage your subscriptions, downloads and invoices.</div>
        </div>
        <div class="page__filters filters filters--purchases">
          <div class="filters__inner">
            <button class="filters__btn" ng-if="$ctrl.data.items" ng-class="{active: $ctrl.tab === 'products'}" ng-click="$ctrl.tab = 'products'">Products</button>
            <button class="filters__btn" ng-if="$ctrl.data.subscriptions" ng-class="{active: $ctrl.tab === 'subscriptions'}" ng-click="$ctrl.tab = 'subscriptions'">Subscriptions</button>
            <button class="filters__btn" ng-if="$ctrl.data.creditPacks" ng-class="{active: $ctrl.tab === 'credits'}" ng-click="$ctrl.tab = 'credits'">Credits</button>
          </div>
        </div>
        <div class="purchases">
          <div class="purchases__list">
            <div ng-if="$ctrl.tab === 'subscriptions'">
              <pass-tile
                ng-repeat="subscription in $ctrl.data.subscriptions"
                subscription="subscription"
                index="$index"
                settings="$ctrl.settings"
                on-card-remove="$ctrl.onCardRemove()"
                active-subscription="$ctrl.activeSubscription"
                on-cancel-subscription="$ctrl.cancelSubscription();"
              ></pass-tile>
            </div>
            <div ng-if="$ctrl.tab === 'products'">
              <order-item ng-repeat="item in $ctrl.nonBundleItems" item="item" user="$ctrl.data.user"></order-item>
              <order-item ng-repeat="item in $ctrl.bundleItems" item="item" user="$ctrl.data.user"></order-item>
            </div>
            <div ng-if="$ctrl.tab === 'credits'">
              <credit-pack-tile
                ng-repeat="pack in $ctrl.data.creditPacks"
                pack="pack"
                show-portal="!$ctrl.billingPortalHidden"
                portal-loading="$ctrl.portalLoading"
                on-portal-click="$ctrl.openBillingPortal()"
              ></credit-pack-tile>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="spage" ng-if="!$ctrl.hasPurchases">
      <div class="spage__container">
        <div class="spage__preview">
          <img src="/img/no-purchases.avif" alt="No purchases yet">
        </div>
        <div class="spage__title">No purchases yet.</div>
        <div class="spage__content">our products, subscriptions, downloads, and invoices will appear here after your first purchase.</div>
        <a href="/category/featured-products" class="btn btn--submit">Explore products</a>
      </div>
      <div class="spage__copyright">© 2026, Robot Global FZCO / UI8.NET</div>
    </div>
    <confirmation-modal
      modal-name="cancel-subscription"
      title="Are you sure you want to cancel?"
      description="Your current rate is locked in forever — even as prices increase with new tools and features. If you cancel now, you may not be able to resubscribe at this rate."
      confirm-text="Cancel anyway"
      cancel-text="Keep my plan"
      on-confirm="$ctrl.cancelSubscription()">
    </confirmation-modal>`,

  controller: function (
    $http,
    ProductService,
    PushService,
    CartService,
    AccountService,
    PaymentService,
    SessionService,
    FlashService
  ) {
    var ctrl = this;

    ctrl.$onInit = function () {
      ctrl.loading = false;
      ctrl.tab = ctrl.data.items
        ? "products"
        : ctrl.data.subscriptions
        ? "subscriptions"
        : "credits";
      ctrl.page = 1;
      ctrl.hasPurchases =
        ctrl.data.subscriptions || ctrl.data.items || ctrl.data.creditPacks;
      ctrl.nonBundleItems = ctrl.data.items
        ? ctrl.data.items.filter(function (i) {
            return i.product.type !== "bundle";
          })
        : null;
      ctrl.bundleItems = ctrl.data.items
        ? ctrl.data.items.filter(function (i) {
            return i.product.type === "bundle";
          })
        : null;

      if (sessionStorage.getItem("new_purchase")) {
        sessionStorage.removeItem("new_purchase");
        var planName =
          ctrl.data.subscriptions && ctrl.data.subscriptions.length
            ? ctrl.data.subscriptions[0].product.cart_name ||
              ctrl.data.subscriptions[0].product.name
            : null;
        var toastMsg = planName
          ? "You're now subsribed to All Access " + planName + " 🎉"
          : "Welcome to UI8 🎉";
        FlashService.set("message", toastMsg, 8000);
      }

      ctrl.addPassToCart = function () {
        CartService.addPassToCart("55314fb422912718375a0196", 1);
      };

      AccountService.settings().then((response) => {
        ctrl.settings = response;
      });

      ctrl.onCardRemove = function () {
        PaymentService.stripeCardRemove(
          ctrl.settings.user.stripe_customer,
          ctrl.settings.defaultCard.id
        )
          .then(() => {
            ctrl.settings.defaultCard = null;
            SessionService.setCurrentUser();
            FlashService.set(
              "message",
              "Auto-renewal for the All Access Pass has been canceled and you will no longer be billed"
            );
          })
          .catch(() => {
            FlashService.set(
              "error",
              "Unable to cancel auto-renewal. Please contact support"
            );
          });
      };

      ctrl.trackPurchaseBanner = function () {
        window.dataLayer.push({
          event: "banner_click",
          element: "purchase_banner",
        });
      };

      initPushNotificationHandler();

      // Check if there is a subscription and cancel it if it's 'active'
      ctrl.activeSubscription = null;

      if (ctrl.data.subscriptions && ctrl.data.subscriptions.length > 0) {
        ctrl.lastSubscription = ctrl.data.subscriptions[0];

        ctrl.lastSubscriptionId =
          ctrl.lastSubscription.paypal_subscription_id ||
          ctrl.lastSubscription.stripe_subscription_id;

        ctrl.isPaypalSubscription =
          ctrl.lastSubscription.paypal_subscription_id;

        if (ctrl.lastSubscriptionId) {
          getActiveSubscription();
        }
      }

      ctrl.cancelSubscription = function () {
        if (!ctrl.activeSubscription) return;

        const url = ctrl.isPaypalSubscription
          ? "/api/paypal/cancel-paypal-subscription"
          : "/api/stripe/cancel-stripe-subscription";

        $http
          .post(url, {
            subscriptionId: ctrl.activeSubscription.id,
          })
          .then(
            function (response) {
              // console.log(response);
              if (response.data.status === "error")
                return FlashService.set("error", response.data.message);
              FlashService.set("message", response.data.message);

              getActiveSubscription();
            },
            function (error) {
              console.log("Error cancelling subscription");
              return FlashService.set(
                "error",
                error.data.error ||
                  error.error ||
                  "Unable to get active subscription. Please try again later."
              );
            }
          );
      };
    };

    ctrl.openBillingPortal = function () {
      ctrl.portalLoading = true;
      $http
        .post("/api/credits/portal", { returnUrl: window.location.href })
        .then(function (response) {
          window.location.href = response.data.url;
        })
        .catch(function (error) {
          ctrl.portalLoading = false;
          if (error.status === 404) {
            ctrl.billingPortalHidden = true;
          }
        });
    };

    ctrl.getCardBackground = function (item) {
      return { "background-image": "url(" + item.product.card_image + ")" };
    };

    ctrl.next = function () {
      ctrl.paginating = true;
      return getPage(ctrl.page + 1);
    };

    function getPage(page) {
      if (ctrl.loading) {
        return;
      }

      ctrl.loading = true;
      ctrl.page = page;

      if (page === 1) {
        ctrl.data.products = [];
      }

      var options = {
        sort: "recent",
        page: ctrl.page,
      };

      ProductService.list(options)
        .then(function (response) {
          ctrl.data.products = ctrl.data.products.concat(response.products);
        })
        .finally(function () {
          ctrl.loading = false;
          ctrl.paginating = false;
        });
    }

    function getActiveSubscription() {
      const url = ctrl.isPaypalSubscription
        ? "/api/paypal/get-paypal-subscription"
        : "/api/stripe/get-stripe-subscription";

      $http
        .get(url, {
          params: {
            subscriptionId: ctrl.lastSubscriptionId,
          },
        })
        .then(
          function (response) {
            // console.log(response);
            ctrl.activeSubscription =
              response.data.status ===
              (ctrl.isPaypalSubscription ? "ACTIVE" : "active")
                ? response.data
                : null;
          },
          function () {
            console.log("Error getting active subscription");
          }
        );
    }

    function initPushNotificationHandler() {
      if (!("serviceWorker" in navigator)) return;

      if (!("PushManager" in window)) return;

      PushService.setUpPush()
        .then(function (subscription) {
          ctrl.pushSubscription = subscription;

          return new Promise(function (resolve) {
            resolve(subscription);
          });
        })
        .then(function (subscription) {
          if (!subscription) {
            return PushService.subscribe();
          } else {
            return new Promise(function (resolve) {
              resolve(subscription);
            });
          }
        })
        .then(function (subscription) {
          ctrl.pushSubscription = subscription;
        })
        .catch(function () {
          ctrl.pushSubscription = null;
        });
    }
  },

  bindings: {
    data: "<",
  },
});
